import React from 'react';

import {
  LegacyText,
  Grid,
  makeStyles,
  Popover,
  IconButton,
  Typography,
  InfoOutlinedIcon,
} from '@gogame/components';

const useStyles = makeStyles(() => ({
  root: {
    width: '560px',
    overflow: 'hidden',
    padding: '8px 16px',
  },
}));

const InfoPopover = ({ data }) => {
  const classes = useStyles();

  return (
    <Popover
      hover
      anchor={<IconButton icon={<InfoOutlinedIcon />} />}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
    >
      <div className={classes.root}>
        <Grid container spacing={2}>
          <Grid item>
            <Typography gutterBottom={true}>GG Link Details</Typography>
          </Grid>

          <Grid item container>
            <Grid item xs={12}>
              <Typography color={'textSecondary'}>Tracking URL</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography
                ellipsis={true}
                lineClamp={4}
                style={{ wordBreak: 'break-all' }}
              >
                {data?.links[0]}
              </Typography>
            </Grid>
          </Grid>

          <Grid item container>
            <Grid item xs={12}>
              <Typography color={'textSecondary'}>Short URL</Typography>
            </Grid>
            <Grid item xs={12}>
              <LegacyText
                ellipsis={true}
                lineClamp={4}
                style={{ wordBreak: 'break-all' }}
              >
                {data?.shortLink}
              </LegacyText>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </Popover>
  );
};

export default InfoPopover;
